'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import classnames from 'classnames';
import { Alert } from '../Alert/Alert.js';

const Toast = _ref => {
  let {
    className,
    position = 'bottom-right',
    autoDismissTime = 10000,
    messages,
    setMessages
  } = _ref;
  const toastRef = useRef(null);
  const [alerts, setAlerts] = useState([]);
  const timeoutsRef = useRef({});
  const reversed = position.includes('top');
  useEffect(() => {
    const msgs = reversed ? [...messages].reverse() : messages;
    const alertComponents = msgs.map(message => {
      const shouldHaveTimeout = !message?.close?.enabled || message?.close?.enabled && message?.autoDismissible;
      if (shouldHaveTimeout && autoDismissTime > 0 && !timeoutsRef.current[message.id]) {
        const timeout = setTimeout(() => {
          if (setMessages) {
            setMessages(prevMessages => prevMessages.filter(msg => msg.id !== message.id));
          }
        }, autoDismissTime);
        timeoutsRef.current[message.id] = timeout;
      }
      return /*#__PURE__*/React__default.createElement(Alert, _extends({}, message, {
        key: message.id,
        close: {
          ...message.close,
          callback: () => {
            if (message.close?.callback) {
              message.close.callback();
            }
            if (timeoutsRef.current[message.id]) {
              clearTimeout(timeoutsRef.current[message.id]);
              delete timeoutsRef.current[message.id];
            }
            if (setMessages) {
              setMessages(prevMessages => prevMessages.filter(msg => msg.id !== message.id));
            }
          }
        }
      }));
    });
    setAlerts(alertComponents);
  }, [messages, setMessages, autoDismissTime]);
  useEffect(() => {
    return () => {
      Object.values(timeoutsRef.current).forEach(clearTimeout);
    };
  }, []);
  useLayoutEffect(() => {
    if (alerts.length && toastRef.current) {
      setTimeout(() => {
        Array.from(toastRef?.current?.children ?? []).forEach(child => {
          const hasActiveClass = child.classList.contains('b-alert__active');
          if (!hasActiveClass) {
            child.classList.add('b-alert__active');
          }
        });
      }, 50);
    }
  }, [alerts, toastRef]);
  const styles = {
    [position.includes('bottom') ? 'bottom' : 'top']: 0,
    [position.includes('left') ? 'left' : 'right']: 0
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-toast', className, {
      'b-toast--top': reversed
    }),
    style: styles,
    "aria-live": "assertive",
    "aria-atomic": "true",
    "data-testid": "toast",
    ref: toastRef
  }, alerts);
};
Toast.displayName = 'Toast';

export { Toast };
